export const buildVersion = '6badb7a'
export const buildTimestamp = 1735736930
